module.exports = __webpack_public_path__ + "static/media/stress-management-large@3x.6fb004be.png";